module.exports = __webpack_public_path__ + "static/media/ic_wave_hand.9299706f.png";